import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Card, CardBody, Spinner } from 'reactstrap';

const DetailRow = ({ label, value, loading }) => (
  <div className="mb-2">
    <strong>{label}:</strong> {loading ? <Spinner size="sm" className="ms-2" /> : (value ?? 0)}
  </div>
);

const OrganizationDetailsModal = ({ open, onClose, organization, fetchMetrics }) => {
  const [metrics, setMetrics] = useState(null);
  const [metricsLoading, setMetricsLoading] = useState(false);

  useEffect(() => {
    if (open && organization?.id) {
      setMetrics(null);
      setMetricsLoading(true);
      fetchMetrics(organization.id).then((data) => {
        setMetrics(data);
        setMetricsLoading(false);
      });
    }
  }, [open, organization?.id]);

  if (!organization) {
    return null;
  }

  return (
    <Modal isOpen={open} toggle={onClose} centered size="lg">
      <ModalHeader toggle={onClose}>
        <span style={{ fontSize: '18px', fontWeight: '700' }}>
          Organization Details
        </span>
      </ModalHeader>
      <ModalBody>
        <Card className="mb-3" style={{ backgroundColor: '#f8f9fa' }}>
          <CardBody>
            <Row>
              <Col md={6}>
                <div className="mb-2">
                  <strong>Organization:</strong> {organization?.name || 'N/A'}
                </div>
                <div className="mb-2">
                  <strong>Website:</strong> {organization?.website || 'N/A'}
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-2">
                  <strong>Type:</strong> {organization?.type || 'N/A'}
                </div>
                <div className="mb-2">
                  <strong>Members:</strong> {organization?.totalMembers || 0}
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <h6 className="mb-3" style={{ fontWeight: '600', fontSize: '16px' }}>
          Match & Engagement Stats
        </h6>
        <Row>
          <Col md={6}>
            <DetailRow label="Brand Matches" value={metrics?.totalBrandMatches} loading={metricsLoading} />
            <DetailRow label="Retailer Matches" value={metrics?.totalRetailerMatches} loading={metricsLoading} />
            <DetailRow label="Brand Revealed Matches" value={metrics?.totalBrandMatchesOpened} loading={metricsLoading} />
          </Col>
          <Col md={6}>
            <DetailRow label="Retailer Revealed Matches" value={metrics?.totalRetailerMatchesOpened} loading={metricsLoading} />
            <DetailRow label="Total Likes" value={metrics?.totalLikes} loading={metricsLoading} />
            <DetailRow label="Total Dislikes" value={metrics?.totalDislikes} loading={metricsLoading} />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OrganizationDetailsModal;
